export const PROFILE_AVATAR_REMOVE_REQUEST = 'profile/avatar-remove-request'
export const PROFILE_AVATAR_REMOVE_SUCCESS = 'profile/avatar-remove-success'
export const PROFILE_AVATAR_REMOVE_FAILED = 'profile/avatar-remove-failed'
